import { useTheme } from '@sds-system/system';
import type { ColorCode } from '@sds-system/types';
import { getColorValue } from '@sds-system/utils';
import { getSpinnerId } from './Spinner.const';
import type { SpinnerProps } from './Spinner.types';

export const SpinnerBar = ({ color, activeColor, variant, name, ...props }: SpinnerProps) => {
  const theme = useTheme();
  const { palette } = theme;

  const svgColor = getColorValue((color || palette.primary[100]) as ColorCode, theme);
  const svgActiveColor = getColorValue(
    (activeColor || palette.bg.interactive.primary) as ColorCode,
    theme,
  );

  const animateIdList = getSpinnerId(8, variant, name);

  return (
    <svg
      fill='none'
      height='48'
      viewBox='0 0 48 48'
      width='48'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect fill={svgColor} height='12' rx='2' width='4' x='22'>
        <animate
          attributeName='fill'
          begin={animateIdList[4]?.begin}
          dur='0.1s'
          from={svgColor}
          id={animateIdList[4]?.id}
          to={svgActiveColor}
        />
      </rect>
      <rect fill={svgColor} height='12' rx='2' width='4' x='22' y='36'>
        <animate
          attributeName='fill'
          begin={animateIdList[0]?.begin}
          dur='0.1s'
          from={svgColor}
          id={animateIdList[0]?.id}
          to={svgActiveColor}
        />
      </rect>
      <rect fill={svgColor} height='12' rx='2' transform='rotate(-90 0 26)' width='4' y='26'>
        <animate
          attributeName='fill'
          begin={animateIdList[2]?.begin}
          dur='0.1s'
          from={svgColor}
          id={animateIdList[2]?.id}
          to={svgActiveColor}
        />
      </rect>
      <rect
        fill={svgColor}
        height='12'
        rx='2'
        transform='rotate(-90 36 26)'
        width='4'
        x='36'
        y='26'
      >
        <animate
          attributeName='fill'
          begin={animateIdList[6]?.begin}
          dur='0.1s'
          from={svgColor}
          id={animateIdList[6]?.id}
          to={svgActiveColor}
        />
      </rect>
      <rect
        fill={svgColor}
        height='12'
        rx='2'
        transform='rotate(-45 5.61523 8.4436)'
        width='4'
        x='5.61523'
        y='8.4436'
      >
        <animate
          attributeName='fill'
          begin={animateIdList[3]?.begin}
          dur='0.1s'
          from={svgColor}
          id={animateIdList[3]?.id}
          to={svgActiveColor}
        />
      </rect>
      <rect
        fill={svgColor}
        height='12'
        rx='2'
        transform='rotate(-45 31.071 33.8995)'
        width='4'
        x='31.071'
        y='33.8995'
      >
        <animate
          attributeName='fill'
          begin={animateIdList[7]?.begin}
          dur='0.1s'
          from={svgColor}
          id={animateIdList[7]?.id}
          to={svgActiveColor}
        />
      </rect>
      <rect
        fill={svgColor}
        height='12'
        rx='2'
        transform='rotate(-135 8.4436 42.3848)'
        width='4'
        x='8.4436'
        y='42.3848'
      >
        <animate
          attributeName='fill'
          begin={animateIdList[1]?.begin}
          dur='0.1s'
          from={svgColor}
          id={animateIdList[1]?.id}
          to={svgActiveColor}
        />
      </rect>
      <rect
        fill={svgColor}
        height='12'
        rx='2'
        transform='rotate(-135 33.8994 16.9288)'
        width='4'
        x='33.8994'
        y='16.9288'
      >
        <animate
          attributeName='fill'
          begin={animateIdList[5]?.begin}
          dur='0.1s'
          from={svgColor}
          id={animateIdList[5]?.id}
          to={svgActiveColor}
        />
      </rect>
    </svg>
  );
};
